import { render, staticRenderFns } from "./push-money-set.vue?vue&type=template&id=ca2a6c72&scoped=true&"
import script from "./push-money-set.vue?vue&type=script&lang=ts&"
export * from "./push-money-set.vue?vue&type=script&lang=ts&"
import style0 from "./push-money-set.vue?vue&type=style&index=0&id=ca2a6c72&prod&lang=scss&scoped=true&"
import style1 from "./push-money-set.vue?vue&type=style&index=1&id=ca2a6c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2a6c72",
  null
  
)

export default component.exports